import { Component, OnInit } from '@angular/core';
import { SalesFileService } from '../../services/sales-file.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { DisplayModes } from '../../../models/enums';


@Component({
  selector: 'crm-user-target-request-approval-users',
  templateUrl: './user-target-request-approval-users.component.html',
  styleUrls: ['./user-target-request-approval-users.component.css']
})
export class UserTargetRequestApprovalUsersComponent implements OnInit {

  levels: any[] = [];
  selectedLevel;
  displayMode: DisplayModes = DisplayModes.Success;
  editMode = false;
  pageSize = 10;
  public logo;

  constructor(private translateService: AppTranslationService, private alertService: AlertService,
     private salesFileService: SalesFileService) { }

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this.alertService.startLoadingMessage("", this.translateService.getTranslation("Searching"));
    this.displayMode = DisplayModes.Loading;

    this.salesFileService.getUserTargetRequestApprovalUsers()
      .subscribe(response => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.levels = response as any[];
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
  }

  gotoEdit(selectedLevel) {
    this.selectedLevel = selectedLevel;
    this.editMode = true;
  }

  closeAdding(event) {
    this.selectedLevel = undefined;
    this.editMode = false;
    if (event) {
      this.getAll();
    }
  }

  getTypeName(type: number): string {
    if (type == 1)
      return "Brand"
    if (type == 2)
      return "Item and parent org type"
    if (type == 3)
      return "Item and child org type"
    if (type == 4)
      return "Item and Hco"
  }

}
